/**
 * PraticheDashboardPage — F-005 Phase 4 (IMPL-P4-006).
 *
 * Dashboard cliente "Le mie pratiche". Lista delle pratiche in corso con
 * polling 20s (BR-6) + heartbeat label "Aggiornato Xs fa".
 *
 * Wrapped da `RequireAuth roles={['CLIENT']}` (registrato in App.tsx) per
 * coerenza con `/pratiche` esistente. Usa `AppLayout` per chrome globale.
 */
import { AppLayout } from '@/components/layout/AppLayout';
import { HeartbeatLabel } from '@/components/HeartbeatLabel';
import { usePraticheList } from '../hooks/usePraticheList';
import { PraticheTable } from '../components/PraticheTable';

export function PraticheDashboardPage() {
  const { data, isPending, isError, dataUpdatedAt } = usePraticheList({
    scope: 'in-progress',
  });

  return (
    <AppLayout>
      <section className="space-y-6">
        <div className="flex items-center justify-between gap-4">
          <h1 className="text-2xl font-semibold tracking-tight">
            Le mie pratiche
          </h1>
          <HeartbeatLabel dataUpdatedAt={dataUpdatedAt} />
        </div>

        {isError && (
          <p
            role="alert"
            className="rounded-md border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive"
          >
            Impossibile caricare le pratiche. Riprova fra qualche secondo.
          </p>
        )}

        <PraticheTable items={data?.items ?? []} isPending={isPending} />
      </section>
    </AppLayout>
  );
}
